/* ============
 * Product Tag Transformer
 * ============
 */

import Transformer from './transformer';

export default class ProductTagTransformer extends Transformer {

  static fetch(model) {
    return {
      id: model.id,
      tag: model.tag,
      productCount: model.product_count,
    };
  }

  static send(model) {
    return {
      id: model.id,
      tag: model.tag,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productTag.js